// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0px;
  padding: 0px;
}

.holidaiy-outer-section {
  height: 80vh;
}
.leave-year-section {
  display: flex;

  height: 55px;
}
.input-button {
  margin-bottom: 10px;
}
.week-days-sections label {
  margin-bottom: 2px;
}

.input-button label {
  margin-left: 2px;
  margin-left: 5px;
  font-size: 0.8rem;
}
.input-button input {
  width: 44%;
  border: 1px solid rgb(211, 209, 209);

  margin-top: -3px;
  margin-right: 2px;
  height: 28px;
}
.input-button input::placeholder {
  color: rgb(167, 167, 167);
  margin-left: 10px;
}
.input-button button {
  height: 30px;
  background-color: rgb(132, 199, 174);
  color: white;
  border-radius: 5px;
  padding: 8px;
  font-size: 0.6rem;
}
.import-holiday-button {
  width: 20%;
  margin: 10px;
}

.import-holiday-button button {
  height: 30px;
  background-color: rgb(132, 199, 174);
  color: white;

  border-radius: 5px;
  margin-left: 109px;
  padding: 10px;
  font-size: 0.6rem;
  margin-top: 35px;
}

.weekly-general-button-section {
  border-bottom: 1px solid black;
  height: 30px;
  display: flex;
  gap: 5px;
  margin-left: 9px;
}
.weekly-general-button-section button {
  background-color: rgb(132, 199, 174);
  color: white;
  padding: 10px;
  font-size: 0.6rem;
}
.weekly-general-button-section .active-button {
  background-color: #0d7c66;
  color: white;
}

.select-day-section {
  margin: 10px;
  & .select-section {
    border: none;
    display: flex;
    height: 5%;
  }
}

.select-day-section select {
  border: 1px solid rgb(225, 225, 225);
  width: 21%;
  height: 30px;

  border-radius: 5px;
  margin-top: -5px;
}
.select-day-section label {
  width: 173px;
  font-size: 0.8rem;
  margin-bottom: 0px;
}

.table_rew_rule {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 40px;
}
.week-select-container {
  margin-top: 10px;
  display: flex;

  align-items: flex-start;
}

.week-option {
  width: 48%;
  display: flex;
  align-items: center;
  gap: 1px;
  margin: -2px;
}
.week-option input {
  width: 20%;
}
.table_holiday_date {
  width: 37%;
}
.half-day-option {
  margin-left: 15px;
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: -8px;
}
.half-day-option input {
  width: 13%;
}
.all-week-container {
  width: 65%;
}
.lable-of-weeks {
  margin-left: 1px;
  width: 10px;
  margin-top: 0px;
}

.table-user-details {
  margin-top: 20px;
  overflow: scroll;
  height: 350px;
}
.add-holiday-container {
  overflow: scroll;
  height: 200px;
}
.add-holiday-container th {
  font-size: 12px;
}
.table-user-details tbody tr:nth-child(odd) {
  /* border: 1px solid #000; */
  background-color: white;
}
.table-user-details th {
  background-color: rgb(216, 243, 216);
  position: sticky;
  top: 0;
  text-align: center;
  padding: 4px 1px;
  font-size: 0.8rem;
}
.table-user-details td {
  font-weight: 600;
  font-size: 14px;
  text-align: center;
  background-color: white;
  padding: 4px 1px;
  border-bottom: 1px solid gray;
}
.week-section-container {
  display: flex;
  /* flex-wrap: wrap;
  gap: 10px; */
  justify-content: space-around;
}

.week-item {
  display: flex;
  align-items: center;
  gap: 3px;
  width: 45px;
  & .lab1 {
    margin-top: 3px;
  }
}

.all-week-container {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin-top: 10px;
}

.week-option {
  display: flex;
  align-items: center;
  gap: 5px;
}

.save-button {
  height: 30px;

  margin-top: 10px;
  text-align: center;
}

.groupName-section {
  display: flex;
  height: 20%;
  & input {
    padding: 5px;
    margin-bottom: 10px;
  }
  & .groupName {
    padding-right: 50px;
  }
}
.Group_header {
  color: #0d7c66;
}

.is-optional-holidat-sectin {
  display: flex;
}
.is-optional-holidat-sectin {
  margin-top: 10px;
  display: flex;
  gap: 4px;
  width: 200px;
}
.is-optional-holidat-sectin input {
  width: 13px;
}

.lable-optinal {
  width: 13px;
  margin-top: 9px;
}

.table-weeek-days {
  width: 100%;

  border-spacing: 0 5px;

  border: 1px solid #d9e3d9;
  overflow: scroll;
}
.hoiday-date {
  width: 11%;
}

.delete-icon {
  cursor: pointer;
}
/* .addGgroup-btn {
  margin-top: 5px;
  margin-left: 20px;
  font-size: 0.8rem;
} */

.AddGroup-section {
  display: flex;
  justify-content: end;
  gap: 10px;
}
/* .global-btn import-button {
  font-size: 12px;
} */

.import_btn {
  padding: 0px;
}
.group-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding-top: 30px;

  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
}

.group-popup {
  position: absolute;
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  z-index: 2;
}

.popup-content h2 {
  margin-top: 0;
  margin-bottom: 15px;
  text-align: center;
}

.popup-content label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}

.popup-content input[type="text"] {
  width: 100%;
  padding: 10px;
  margin-bottom: 15px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}

.popup-content button {
  color: black;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 18px;
}

.add-weeks-button {
  height: 45px;
  width: 98%;

  margin: 10px;

  display: flex;
  justify-content: end;
  gap: 5px;
}

.add-weeks-button button {
  background-color: rgb(132, 199, 174);
  color: white;
  height: 30px;
  width: 68px;
  border-radius: 4px;
  cursor: pointer;
  border: none;
  outline: none;

  font-size: 0.7rem;
}

.week-days-input {
  border: 1px solid gray;
  height: 25px;
  border-radius: 4px;
  width: 30%;
}

.weekDays-tr {
  width: 100%;
}

.days-weeks-popup-section {
  border: 1px solid black;
  background-color: rgb(245, 247, 245);
  padding: 30px;
  border-radius: 12px;
  position: relative;
  width: 375px;
  max-width: 90%;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}
.crossIconOfHolidays {
  position: absolute;
  top: 10px;
  right: 2%;
  cursor: pointer;
  z-index: 999;
}
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.day-week-show-button {
  background-color: rgb(132, 199, 174);

  border-radius: 4px;
  height: 30px;
  width: 70px;
  font-size: 0.7rem;
  text-align: center;
  padding: 8px;
  color: white;
  cursor: pointer;
}
.weekoff-table-wrapper {
  width: 100%;
  margin-top: 10px;
}
.weekoff-table-title {
  display: block;
  font-size: 0.9rem;
  font-weight: 700;
  color: #0d7c66;
  margin-bottom: 6px;
}

.weekoff-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #d9e3d9;
  background-color: #fff;
  color: #555;
}

.weekoff-table th {
  background-color: rgb(216, 243, 216);
  font-size: 0.6rem;
  font-weight: 700;
  text-align: center;
  /* padding: 10px 6px; */
  border: 1px solid #d9e3d9;
}

.weekoff-table td {
  border: 1px solid #d9e3d9;
  /* padding: 10px 6px; */
}

.weekoff-day-cell {
  font-weight: 700;
  text-align: center;
  width: 70px;
  background-color: #f5f5f5;
}

.weekoff-check-cell {
  text-align: center;
}

.weekoff-check-cell input {
  width: 13px;
  height: 13px;
  cursor: pointer;
}

.weekoff-table th[colspan] {
  text-align: center;
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .holidaiy-outer-section {
    height: 80vh;
  }
  .weekly-general-button-section {
    border-bottom: 1px solid black;
    height: 30px;
    display: flex;
    gap: 5px;
    margin-left: 9px;
  }
  .weekly-general-button-section .active-button {
    background-color: #0d7c66;
    color: white;
  }
  .weekly-general-button-section button {
    background-color: rgb(132, 199, 174);
    color: white;
    padding: 10px;
    font-size: 0.6rem;
  }
  .select-day-section {
    margin: 10px;
  }
  .add-weeks-button {
    height: 45px;
    width: 98%;
    margin: 10px;
    display: flex;
    justify-content: end;
    gap: 5px;
  }
  .add-weeks-button button {
    background-color: rgb(132, 199, 174);
    color: white;
    height: 30px;
    width: 68px;
    border-radius: 4px;
    cursor: pointer;
    border: none;
    outline: none;
    font-size: 0.7rem;
  }
  .day-week-show-button {
    background-color: rgb(132, 199, 174);
    border-radius: 4px;
    height: 30px;
    width: 70px;
    font-size: 0.7rem;
    text-align: center;
    padding: 8px;
    color: white;
    cursor: pointer;
  }
}

/* Small Desktops & Laptops: 1025px to 1439px */
@media screen and (min-width: 1025px) and (max-width: 1440px) {
  .holidaiy-outer-section {
    height: 80vh;
  }
  .weekly-general-button-section {
    border-bottom: 1px solid black;
    height: 30px;
    display: flex;
    gap: 5px;
    margin-left: 9px;
  }
  .weekly-general-button-section .active-button {
    background-color: #0d7c66;
    color: white;
  }
  .weekly-general-button-section button {
    background-color: rgb(132, 199, 174);
    color: white;
    padding: 10px;
    font-size: 0.6rem;
  }
  .select-day-section {
    margin: 10px;
  }
  .table-user-details {
    margin-top: 20px;
  }
  .add-weeks-button {
    height: 45px;
    width: 98%;
    margin: 10px;
    display: flex;
    justify-content: end;
    gap: 5px;
  }
  .add-weeks-button button {
    background-color: rgb(132, 199, 174);
    color: white;
    height: 30px;
    width: 68px;
    border-radius: 4px;
    cursor: pointer;
    border: none;
    outline: none;
    font-size: 0.7rem;
  }
  .day-week-show-button {
    background-color: rgb(132, 199, 174);
    border-radius: 4px;
    height: 30px;
    width: 70px;
    font-size: 0.7rem;
    text-align: center;
    padding: 8px;
    color: white;
    cursor: pointer;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/HolidaysComponent/holidays.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;AACd;AACA;EACE,aAAa;;EAEb,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,oCAAoC;;EAEpC,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,oCAAoC;EACpC,YAAY;;EAEZ,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,oCAAoC;EACpC,YAAY;EACZ,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ;IACE,YAAY;IACZ,aAAa;IACb,UAAU;EACZ;AACF;;AAEA;EACE,oCAAoC;EACpC,UAAU;EACV,YAAY;;EAEZ,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,aAAa;;EAEb,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,4BAA4B;EAC5B,uBAAuB;AACzB;AACA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,MAAM;EACN,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb;cACY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;;EAEZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX;IACE,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,QAAQ;EACR,YAAY;AACd;AACA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;;EAEX,qBAAqB;;EAErB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;AACA;;;;GAIG;;AAEH;EACE,aAAa;EACb,oBAAoB;EACpB,SAAS;AACX;AACA;;GAEG;;AAEH;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;;EAEjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,UAAU;;EAEV,YAAY;;EAEZ,aAAa;EACb,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,aAAa;;EAEb,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,yCAAyC;AAC3C;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,eAAe;EACf,YAAY;AACd;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,oCAAoC;;EAEpC,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,8BAA8B;IAC9B,YAAY;IACZ,aAAa;IACb,QAAQ;IACR,gBAAgB;EAClB;EACA;IACE,yBAAyB;IACzB,YAAY;EACd;EACA;IACE,oCAAoC;IACpC,YAAY;IACZ,aAAa;IACb,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,aAAa;IACb,oBAAoB;IACpB,QAAQ;EACV;EACA;IACE,oCAAoC;IACpC,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,aAAa;IACb,iBAAiB;EACnB;EACA;IACE,oCAAoC;IACpC,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA,+CAA+C;AAC/C;EACE;IACE,YAAY;EACd;EACA;IACE,8BAA8B;IAC9B,YAAY;IACZ,aAAa;IACb,QAAQ;IACR,gBAAgB;EAClB;EACA;IACE,yBAAyB;IACzB,YAAY;EACd;EACA;IACE,oCAAoC;IACpC,YAAY;IACZ,aAAa;IACb,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;IACE,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,aAAa;IACb,oBAAoB;IACpB,QAAQ;EACV;EACA;IACE,oCAAoC;IACpC,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,aAAa;IACb,iBAAiB;EACnB;EACA;IACE,oCAAoC;IACpC,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,eAAe;EACjB;AACF","sourcesContent":["* {\n  margin: 0px;\n  padding: 0px;\n}\n\n.holidaiy-outer-section {\n  height: 80vh;\n}\n.leave-year-section {\n  display: flex;\n\n  height: 55px;\n}\n.input-button {\n  margin-bottom: 10px;\n}\n.week-days-sections label {\n  margin-bottom: 2px;\n}\n\n.input-button label {\n  margin-left: 2px;\n  margin-left: 5px;\n  font-size: 0.8rem;\n}\n.input-button input {\n  width: 44%;\n  border: 1px solid rgb(211, 209, 209);\n\n  margin-top: -3px;\n  margin-right: 2px;\n  height: 28px;\n}\n.input-button input::placeholder {\n  color: rgb(167, 167, 167);\n  margin-left: 10px;\n}\n.input-button button {\n  height: 30px;\n  background-color: rgb(132, 199, 174);\n  color: white;\n  border-radius: 5px;\n  padding: 8px;\n  font-size: 0.6rem;\n}\n.import-holiday-button {\n  width: 20%;\n  margin: 10px;\n}\n\n.import-holiday-button button {\n  height: 30px;\n  background-color: rgb(132, 199, 174);\n  color: white;\n\n  border-radius: 5px;\n  margin-left: 109px;\n  padding: 10px;\n  font-size: 0.6rem;\n  margin-top: 35px;\n}\n\n.weekly-general-button-section {\n  border-bottom: 1px solid black;\n  height: 30px;\n  display: flex;\n  gap: 5px;\n  margin-left: 9px;\n}\n.weekly-general-button-section button {\n  background-color: rgb(132, 199, 174);\n  color: white;\n  padding: 10px;\n  font-size: 0.6rem;\n}\n.weekly-general-button-section .active-button {\n  background-color: #0d7c66;\n  color: white;\n}\n\n.select-day-section {\n  margin: 10px;\n  & .select-section {\n    border: none;\n    display: flex;\n    height: 5%;\n  }\n}\n\n.select-day-section select {\n  border: 1px solid rgb(225, 225, 225);\n  width: 21%;\n  height: 30px;\n\n  border-radius: 5px;\n  margin-top: -5px;\n}\n.select-day-section label {\n  width: 173px;\n  font-size: 0.8rem;\n  margin-bottom: 0px;\n}\n\n.table_rew_rule {\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 40px;\n}\n.week-select-container {\n  margin-top: 10px;\n  display: flex;\n\n  align-items: flex-start;\n}\n\n.week-option {\n  width: 48%;\n  display: flex;\n  align-items: center;\n  gap: 1px;\n  margin: -2px;\n}\n.week-option input {\n  width: 20%;\n}\n.table_holiday_date {\n  width: 37%;\n}\n.half-day-option {\n  margin-left: 15px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-top: -8px;\n}\n.half-day-option input {\n  width: 13%;\n}\n.all-week-container {\n  width: 65%;\n}\n.lable-of-weeks {\n  margin-left: 1px;\n  width: 10px;\n  margin-top: 0px;\n}\n\n.table-user-details {\n  margin-top: 20px;\n  overflow: scroll;\n  height: 350px;\n}\n.add-holiday-container {\n  overflow: scroll;\n  height: 200px;\n}\n.add-holiday-container th {\n  font-size: 12px;\n}\n.table-user-details tbody tr:nth-child(odd) {\n  /* border: 1px solid #000; */\n  background-color: white;\n}\n.table-user-details th {\n  background-color: rgb(216, 243, 216);\n  position: sticky;\n  top: 0;\n  text-align: center;\n  padding: 4px 1px;\n  font-size: 0.8rem;\n}\n.table-user-details td {\n  font-weight: 600;\n  font-size: 14px;\n  text-align: center;\n  background-color: white;\n  padding: 4px 1px;\n  border-bottom: 1px solid gray;\n}\n.week-section-container {\n  display: flex;\n  /* flex-wrap: wrap;\n  gap: 10px; */\n  justify-content: space-around;\n}\n\n.week-item {\n  display: flex;\n  align-items: center;\n  gap: 3px;\n  width: 45px;\n  & .lab1 {\n    margin-top: 3px;\n  }\n}\n\n.all-week-container {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n  margin-top: 10px;\n}\n\n.week-option {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.save-button {\n  height: 30px;\n\n  margin-top: 10px;\n  text-align: center;\n}\n\n.groupName-section {\n  display: flex;\n  height: 20%;\n  & input {\n    padding: 5px;\n    margin-bottom: 10px;\n  }\n  & .groupName {\n    padding-right: 50px;\n  }\n}\n.Group_header {\n  color: #0d7c66;\n}\n\n.is-optional-holidat-sectin {\n  display: flex;\n}\n.is-optional-holidat-sectin {\n  margin-top: 10px;\n  display: flex;\n  gap: 4px;\n  width: 200px;\n}\n.is-optional-holidat-sectin input {\n  width: 13px;\n}\n\n.lable-optinal {\n  width: 13px;\n  margin-top: 9px;\n}\n\n.table-weeek-days {\n  width: 100%;\n\n  border-spacing: 0 5px;\n\n  border: 1px solid #d9e3d9;\n  overflow: scroll;\n}\n.hoiday-date {\n  width: 11%;\n}\n\n.delete-icon {\n  cursor: pointer;\n}\n/* .addGgroup-btn {\n  margin-top: 5px;\n  margin-left: 20px;\n  font-size: 0.8rem;\n} */\n\n.AddGroup-section {\n  display: flex;\n  justify-content: end;\n  gap: 10px;\n}\n/* .global-btn import-button {\n  font-size: 12px;\n} */\n\n.import_btn {\n  padding: 0px;\n}\n.group-popup-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  padding-top: 30px;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1;\n}\n\n.group-popup {\n  position: absolute;\n  background-color: white;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  z-index: 2;\n}\n\n.popup-content h2 {\n  margin-top: 0;\n  margin-bottom: 15px;\n  text-align: center;\n}\n\n.popup-content label {\n  display: block;\n  margin-bottom: 5px;\n  font-weight: bold;\n}\n\n.popup-content input[type=\"text\"] {\n  width: 100%;\n  padding: 10px;\n  margin-bottom: 15px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  box-sizing: border-box;\n}\n\n.popup-content button {\n  color: black;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 18px;\n}\n\n.add-weeks-button {\n  height: 45px;\n  width: 98%;\n\n  margin: 10px;\n\n  display: flex;\n  justify-content: end;\n  gap: 5px;\n}\n\n.add-weeks-button button {\n  background-color: rgb(132, 199, 174);\n  color: white;\n  height: 30px;\n  width: 68px;\n  border-radius: 4px;\n  cursor: pointer;\n  border: none;\n  outline: none;\n\n  font-size: 0.7rem;\n}\n\n.week-days-input {\n  border: 1px solid gray;\n  height: 25px;\n  border-radius: 4px;\n  width: 30%;\n}\n\n.weekDays-tr {\n  width: 100%;\n}\n\n.days-weeks-popup-section {\n  border: 1px solid black;\n  background-color: rgb(245, 247, 245);\n  padding: 30px;\n  border-radius: 12px;\n  position: relative;\n  width: 375px;\n  max-width: 90%;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n.crossIconOfHolidays {\n  position: absolute;\n  top: 10px;\n  right: 2%;\n  cursor: pointer;\n  z-index: 999;\n}\n.popup-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.3);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n.day-week-show-button {\n  background-color: rgb(132, 199, 174);\n\n  border-radius: 4px;\n  height: 30px;\n  width: 70px;\n  font-size: 0.7rem;\n  text-align: center;\n  padding: 8px;\n  color: white;\n  cursor: pointer;\n}\n.weekoff-table-wrapper {\n  width: 100%;\n  margin-top: 10px;\n}\n.weekoff-table-title {\n  display: block;\n  font-size: 0.9rem;\n  font-weight: 700;\n  color: #0d7c66;\n  margin-bottom: 6px;\n}\n\n.weekoff-table {\n  width: 100%;\n  border-collapse: collapse;\n  border: 1px solid #d9e3d9;\n  background-color: #fff;\n  color: #555;\n}\n\n.weekoff-table th {\n  background-color: rgb(216, 243, 216);\n  font-size: 0.6rem;\n  font-weight: 700;\n  text-align: center;\n  /* padding: 10px 6px; */\n  border: 1px solid #d9e3d9;\n}\n\n.weekoff-table td {\n  border: 1px solid #d9e3d9;\n  /* padding: 10px 6px; */\n}\n\n.weekoff-day-cell {\n  font-weight: 700;\n  text-align: center;\n  width: 70px;\n  background-color: #f5f5f5;\n}\n\n.weekoff-check-cell {\n  text-align: center;\n}\n\n.weekoff-check-cell input {\n  width: 13px;\n  height: 13px;\n  cursor: pointer;\n}\n\n.weekoff-table th[colspan] {\n  text-align: center;\n}\n@media screen and (min-width: 768px) and (max-width: 1024px) {\n  .holidaiy-outer-section {\n    height: 80vh;\n  }\n  .weekly-general-button-section {\n    border-bottom: 1px solid black;\n    height: 30px;\n    display: flex;\n    gap: 5px;\n    margin-left: 9px;\n  }\n  .weekly-general-button-section .active-button {\n    background-color: #0d7c66;\n    color: white;\n  }\n  .weekly-general-button-section button {\n    background-color: rgb(132, 199, 174);\n    color: white;\n    padding: 10px;\n    font-size: 0.6rem;\n  }\n  .select-day-section {\n    margin: 10px;\n  }\n  .add-weeks-button {\n    height: 45px;\n    width: 98%;\n    margin: 10px;\n    display: flex;\n    justify-content: end;\n    gap: 5px;\n  }\n  .add-weeks-button button {\n    background-color: rgb(132, 199, 174);\n    color: white;\n    height: 30px;\n    width: 68px;\n    border-radius: 4px;\n    cursor: pointer;\n    border: none;\n    outline: none;\n    font-size: 0.7rem;\n  }\n  .day-week-show-button {\n    background-color: rgb(132, 199, 174);\n    border-radius: 4px;\n    height: 30px;\n    width: 70px;\n    font-size: 0.7rem;\n    text-align: center;\n    padding: 8px;\n    color: white;\n    cursor: pointer;\n  }\n}\n\n/* Small Desktops & Laptops: 1025px to 1439px */\n@media screen and (min-width: 1025px) and (max-width: 1440px) {\n  .holidaiy-outer-section {\n    height: 80vh;\n  }\n  .weekly-general-button-section {\n    border-bottom: 1px solid black;\n    height: 30px;\n    display: flex;\n    gap: 5px;\n    margin-left: 9px;\n  }\n  .weekly-general-button-section .active-button {\n    background-color: #0d7c66;\n    color: white;\n  }\n  .weekly-general-button-section button {\n    background-color: rgb(132, 199, 174);\n    color: white;\n    padding: 10px;\n    font-size: 0.6rem;\n  }\n  .select-day-section {\n    margin: 10px;\n  }\n  .table-user-details {\n    margin-top: 20px;\n  }\n  .add-weeks-button {\n    height: 45px;\n    width: 98%;\n    margin: 10px;\n    display: flex;\n    justify-content: end;\n    gap: 5px;\n  }\n  .add-weeks-button button {\n    background-color: rgb(132, 199, 174);\n    color: white;\n    height: 30px;\n    width: 68px;\n    border-radius: 4px;\n    cursor: pointer;\n    border: none;\n    outline: none;\n    font-size: 0.7rem;\n  }\n  .day-week-show-button {\n    background-color: rgb(132, 199, 174);\n    border-radius: 4px;\n    height: 30px;\n    width: 70px;\n    font-size: 0.7rem;\n    text-align: center;\n    padding: 8px;\n    color: white;\n    cursor: pointer;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
